export const dtCopy = {
  dt_s_page_title: "Szukaj typowanych pakietów",
  dt_s_title: "Szukaj typowanych",
  dt_s_subtitle:
    "Znajdź pakiety npm, które mają deklaracje typu w pakiecie lub są Definitely Typed.",
  dt_s_match: "pasuje",
  dt_s_matchs: "pasujący",
  dt_s_match_exact: "Dokładne dopasowanie",
  dt_s_popular_on_dt: "Popularne Definitely Typed",
  dt_s_downloads_short: "PB",
  dt_s_downloads_via: "Przez",
  dt_s_module: "Moduł",
  dt_s_last_update: "Data ostatniej aktualizacji",
  dt_s_install: "Instalacja",
  dt_s_no_results: "Nie znaleziono wyników dla",
  dt_s_no_results_try: "Spróbuj innego wyszukiwania?",
  dt_s_copy: "kopiuj",
  dt_s_copied: "skopiowane",
}
